import Past from './Past'

export default Past
